import PropTypes from 'prop-types';

export const markerProps = {
    // id that uniquely idenitifies a marker, to be used a key as well
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    // position that will anchor the marker on the map
    position: PropTypes.shape({
        // latitude used to center the marker
        lat: PropTypes.number,

        // longitude used to center the marker
        lng: PropTypes.number,
    }),
    // thumnail to be displayed in map marker
    thumbnail: PropTypes.string,
    // array of litter tags to be displayed inside marker
    tags: PropTypes.arrayOf(PropTypes.string),
    // Icon for the foreground. If a string is provided, it is treated as though it were an Icon with the string as url.
    icon: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
};
